import axios from "axios";

export const state = {
    smsbundles: [],
};

export const getters = {
    smsbundles: state => state.smsbundles,
};

export const mutations = {
    setSmsbundles(state, newValue) {
        state.smsbundles = newValue
    },
};

export const actions = {
    fetchSmsBundles({ commit }) {
        axios.get('/smsbundles').then(res => {
            commit('setSmsbundles', res.data.sms_bundles)
        })
    },
};
